module.exports = __webpack_public_path__ + "img/product3.e1115906.png";